import { Content, SubjectCard } from '@ftrprf/tailwind-components';
import Header from 'components/Header/Header';
import useFormatMessage from 'hooks/useFormatMessage';
import URLS from 'utils/constants/urls';
import Scratch from 'assets/vectors/scratch.svg';
import Wijs from 'assets/wijs.png';
import itMe from 'assets/it_me.png';
import useTitle from '../hooks/useTitle';

export function IntroPage() {
  const t = useFormatMessage();
  useTitle(t('demo.superlight.intropage.title'));

  return (
    <>
      <header className="w-full">
        <Header />
      </header>
      <main className="w-full h-full">
        <Content className="h-full">
          <div className="flex flex-col w-full">
            <ul className="mt-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              <li className="chapterItem">
                <SubjectCard
                  color="#10b981"
                  hasContent
                  image={itMe}
                  isDemo
                  link={URLS.IT}
                  title={t('demo.superlight.intropage.it')}
                />
              </li>
              <li className="cursor-pointer chapterItem">
                <SubjectCard
                  color="#10b981"
                  hasContent
                  image={Scratch}
                  isDemo
                  link={URLS.SCRATCH}
                  title={t('demo.superlight.intropage.scratch')}
                />
              </li>
              <li className="cursor-pointer chapterItem">
                <SubjectCard
                  color="#10b981"
                  hasContent
                  image={Wijs}
                  isDemo
                  link={URLS.WIJS}
                  title={t('demo.superlight.intropage.wijs')}
                />
              </li>
            </ul>
          </div>
        </Content>
      </main>
    </>
  );
}
